import { render, staticRenderFns } from "./GroupedRows.vue?vue&type=template&id=2f838595&"
import script from "./GroupedRows.vue?vue&type=script&lang=js&"
export * from "./GroupedRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports